import React, { useState } from 'react';
import type { BookingResponse } from '@fittrack/services';
import '../styles/BookingConfirmation.css';

interface BookingConfirmationProps {
  bookingResponse: BookingResponse;
  onClose: () => void;
}

const BookingConfirmation: React.FC<BookingConfirmationProps> = ({ bookingResponse, onClose }) => {
  const { confirmation } = bookingResponse;
  const [photoFailed, setPhotoFailed] = useState(false);

  if (!confirmation) {
    return null;
  }

  return (
    <div className="confirmation-overlay" onClick={onClose}>
      <div className="confirmation-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirmation-content">
          <div className="confirmation-header">
            <h1>Booking Succeeded!</h1>
            <button className="confirmation-close-btn" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>

          <div className="confirmation-body">
            <div className="photo-section">
              {confirmation.photoUrl && !photoFailed ? (
                <img
                  src={confirmation.photoUrl}
                  alt={confirmation.personName}
                  className="person-photo"
                  onError={() => setPhotoFailed(true)}
                />
              ) : (
                <div className="person-photo person-photo--placeholder" role="img" aria-label={confirmation.personName}>
                  😊
                </div>
              )}
            </div>

            {confirmation.qrCodeUrl && (
              <div className="qr-section">
                <div className="qr-code">
                  {confirmation.qrCodeUrl.startsWith('http') ? (
                    <img src={confirmation.qrCodeUrl} alt="QR Code" />
                  ) : (
                    <div className="qr-placeholder">
                      <p>QR Code</p>
                      <p className="scan-code">{confirmation.qrCodeUrl}</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="warning-text">
              <p>
                SCAN QR ABOVE AT CLUB FOR ACCESS AND PLEASE CAPTURE AND SAVE FOR YOUR PERSONAL USE ONLY.
              </p>
              <p>
                NOTE: IF YOU SHARE YOUR CODE OR USE ANYONE ELSE'S, BOTH PARTIES' GYM ACCESS MAY BE REVOKED
                AND/OR ADDITIONAL UNAUTHORIZED ACCESS FEES WILL BE CHARGED.
              </p>
            </div>

            <div className="location-info">
              <p className="site-name">{confirmation.siteName}</p>
              <p className="site-address">{confirmation.siteAddress1}</p>
              <p className="site-address">{confirmation.siteAddress2}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmation;
